import React, { Suspense } from 'react';
import { Loader2 } from 'lucide-react';

export const CHUNK_RELOAD_SESSION_KEY = 'soluqr_chunk_reload_once';

export function isChunkLoadError(err) {
  const msg = String(err?.message || err || '');
  return err?.name === 'ChunkLoadError' || /Loading chunk [\w.-]+ failed/i.test(msg);
}

/** Tras deploy, el main.js cacheado puede pedir chunks que ya no existen — recarga una vez. */
export function importWithChunkRetry(importFactory) {
  return importFactory().catch((err) => {
    if (
      isChunkLoadError(err) &&
      typeof window !== 'undefined' &&
      !sessionStorage.getItem(CHUNK_RELOAD_SESSION_KEY)
    ) {
      sessionStorage.setItem(CHUNK_RELOAD_SESSION_KEY, '1');
      window.location.reload();
      return new Promise(() => {});
    }
    if (typeof window !== 'undefined') {
      sessionStorage.removeItem(CHUNK_RELOAD_SESSION_KEY);
    }
    throw err;
  });
}

export function clearChunkReloadFlag() {
  if (typeof window !== 'undefined') {
    sessionStorage.removeItem(CHUNK_RELOAD_SESSION_KEY);
  }
}

export function PageLoadFallback({ minHeight = '40vh' } = {}) {
  return (
    <div
      className="flex w-full items-center justify-center"
      style={{ minHeight }}
      role="status"
      aria-live="polite"
      aria-label="Cargando página"
    >
      <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" aria-hidden />
    </div>
  );
}

/** Lazy route component con Suspense (mismo patrón que dashboardRoutes). */
export function lazyPageComponent(importFactory) {
  const Lazy = React.lazy(() => importWithChunkRetry(importFactory));
  function LazyPageRoute(props) {
    return (
      <Suspense fallback={<PageLoadFallback />}>
        <Lazy {...props} />
      </Suspense>
    );
  }
  return LazyPageRoute;
}

/** Lazy child (tabs admin) con retry de chunk. */
export function lazyComponent(importFactory) {
  return React.lazy(() => importWithChunkRetry(importFactory));
}
